module.exports = "<div class=\"holder\" [ngClass]=\"{'control': pin.type == pin.types.control, 'shadow': shadow, 'selected': selected}\">\n  <div class=\"ace-holder\">\n    <ace-editor mode=\"javascript\"\n                [(text)]=\"_code\"\n                [options]=\"options\"\n                style='min-height:16px;'></ace-editor>\n  </div>\n  <editor-pin [pin]=\"pin\"></editor-pin>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/editor/code/code.component.html
// module id = ./src/app/components/editor/code/code.component.html
// module chunks = main